import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './shared/authentication/login/login.component';
import { LogoutComponent } from './shared/authentication/logout/logout.component';
import { BrowserUtils } from '@azure/msal-browser';
import { MsalRedirectComponent } from '@azure/msal-angular';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'post-logout', component: LogoutComponent },
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    component: MsalRedirectComponent,
    matcher: url => {
      return url.length === 1 && url[0].path.startsWith('code') ? { consumed: url } : null;
    },
  },
];

const isIframe = window !== window.parent && !window.opener;

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      // enableTracing: !environment.production && logger.debugEnabled,
      // Don't perform initial navigation in iframes or popups
      initialNavigation: !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup() ? 'enabledNonBlocking' : 'disabled', // Set to enabledBlocking to use Angular Universal
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
